import CTASection from "../components/CTASection";
export default function Cookie() {
  return (
    <div id="main-content" className="pt-20" data-testid="cookie-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Cookie Policy
          </h1>
          <p className="text-sm text-gray-400 mb-8">Last Updated: January 2026</p>

          <div className="space-y-8 text-gray-300">
            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">What Are Cookies?</h2>
              <p className="text-gray-400">
                Cookies are small text files that are placed on your device when you visit a website. They help the website remember 
                your preferences and improve your browsing experience.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Types of Cookies We Use</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium mb-2 text-gray-200">Essential Cookies</h3>
                  <p className="text-gray-400 text-sm">
                    These cookies are necessary for the website to function properly. They enable basic features like page navigation 
                    and access to secure areas. The website cannot function properly without these cookies.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium mb-2 text-gray-200">Preference Cookies</h3>
                  <p className="text-gray-400 text-sm">
                    These cookies remember your choices (such as language or region) and provide enhanced features. They help us 
                    personalize your experience on our website.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium mb-2 text-gray-200">Analytics Cookies</h3>
                  <p className="text-gray-400 text-sm">
                    These cookies help us understand how visitors interact with our website by collecting and reporting information 
                    anonymously. This data helps us improve the website's functionality and user experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">How We Use Cookies</h2>
              <ul className="space-y-2 text-gray-400 text-sm ml-6">
                <li className="list-disc">To remember your cookie consent preferences</li>
                <li className="list-disc">To analyze website traffic and usage patterns</li>
                <li className="list-disc">To improve website performance and user experience</li>
                <li className="list-disc">To remember your preferences and settings</li>
              </ul>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Managing Cookies</h2>
              <p className="text-gray-400 mb-4">
                You can control and manage cookies in various ways:
              </p>
              <ul className="space-y-3 text-gray-400 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span><strong className="text-gray-200">Cookie Banner:</strong> When you first visit our website, you can accept or decline non-essential cookies via our cookie banner.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span><strong className="text-gray-200">Browser Settings:</strong> Most browsers allow you to refuse cookies or delete cookies. The method varies by browser and version. Check your browser's help menu for instructions.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#d4af69] mt-1">•</span>
                  <span><strong className="text-gray-200">Third-Party Tools:</strong> You can opt-out of third-party cookies via industry opt-out programs.</span>
                </li>
              </ul>
              <p className="text-gray-400 mt-4 text-sm">
                Please note that blocking or deleting cookies may impact your experience on our website and limit certain functionalities.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Third-Party Cookies</h2>
              <p className="text-gray-400">
                We may use third-party service providers (such as analytics platforms) that set their own cookies to provide their services. 
                We do not control these third-party cookies. Please refer to the privacy policies of these third parties for more information.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Updates to This Policy</h2>
              <p className="text-gray-400">
                We may update this Cookie Policy from time to time to reflect changes in our practices or for legal or regulatory reasons. 
                Please check this page periodically for updates.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Contact Us</h2>
              <p className="text-gray-400">
                If you have questions about our use of cookies, please contact us at{" "}
                <a href="mailto:info@kredere.com" className="text-[#d4af69] hover:underline">
                  info@kredere.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}